// Exports the "autosave" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/autosave')
//   ES2015:
//     import 'tinymce/plugins/autosave'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ./~/tinymce/plugins/autosave/index.js
// module id = 571
// module chunks = 0